import React from 'react';

import {
  
  Botafogo,
  Palmeiras,
  AtleticoMineiro,
  Flamengo,
  Corinthians,
  Cruzeiro,
  Fluminense,
  SaoPaulo,
  Santos,
  VascoDaGama,
  AtleticoParanaense,
  Gremio,
  Bahia,
  SportRacife,
  Coritiba,
  

} from "../clubs";

const BrasileiroSerieA = () => {
  return (
    <div>
      <h1>Dates of the last league titles for each club that has won Campeonato Brasileiro Série A.</h1>
      <Flamengo />
      <Botafogo />
      <Palmeiras />
      <AtleticoMineiro />
      <Corinthians />
      <Cruzeiro />
      <Fluminense />
      <SaoPaulo />
      <Santos />
      <VascoDaGama />
      <AtleticoParanaense />
      <Gremio />
      <Bahia />
      <SportRacife />
      <Coritiba />

    </div>
  )
}

export default BrasileiroSerieA


